export default {
    state: {
        notifications: {},
        listNotificationNotRead:{
            data: []
        }
    },
    actions: {
        LOAD_NOTIFICATIONS({ commit }, payload) {
            let { page, order, column, search, filter, per_page, user_id } = payload;

            return window.axios
                .get(`/api/app/website-notifications/list`, {
                    params: { page, order, column, search, filter, per_page, user_id }
                })
                .then(res => {
                    commit("SET_NOTIFICATION", res.data);
                    commit("VERIFY_LIST_NOTIFICATIONS", res.data);
                })
                .catch(err => console.error(err));
        },
        SET_NOTIFICATION_READ({ commit }, payload) {
            return window.axios
                .put(`/api/app/seen/${payload}`)
                .then(res => {
                    commit("MARK_NOTIFICATION_READ", payload);
                    return res;
                })
                .catch(err => console.error(err));
        },
        SET_NOTIFICATION_READ_ALL({ commit }, payload) {
            return window.axios
                .put(`/api/app/seen-all-notifications/${payload}`)
                .then(() => {
                   commit('MARK_ALL_NOTIFICATION_READ');
                })
                .catch(err => console.error(err));
        }
    },
    mutations: {
        SET_NOTIFICATION(state, payload) {
            state.notifications = payload;
        },
        VERIFY_LIST_NOTIFICATIONS(state, payload){

            const newData = payload;
            const currentList = state.listNotificationNotRead.data
            
            const notificationNotRead = newData.data.filter(notification => !notification.read);
            const newNotifications = [ ...notificationNotRead ]; 

            let insertNotifications = [];
            if(currentList && currentList.length){
                for(let newNotification of newNotifications){
                    const verify = currentList.some(currentNotification => currentNotification.id === newNotification.id);

                    if(!verify){
                        insertNotifications.push(newNotification);
                    }
                }
            }else{
                insertNotifications = [ ...newNotifications ];
            }

            if(insertNotifications.length){
                state.listNotificationNotRead.data = [ ...currentList, ...insertNotifications];
            }else{
                state.listNotificationNotRead.data = [ ...currentList]
            }

            state.listNotificationNotRead.links = newData.links;
            state.listNotificationNotRead.meta = newData.meta;
        },
        MARK_NOTIFICATION_READ(state, payload){
            const filterNotificationList = state.listNotificationNotRead.data.filter(notification => notification.id !== payload);
            state.listNotificationNotRead.data = [ ...filterNotificationList ];
        },
        MARK_ALL_NOTIFICATION_READ(state){
            state.listNotificationNotRead.data = []; 
        }
    },
    getters: {
        LOADED_NOTIFICATIONS(state) {
            return state.notifications;
        },
        LOADED_NOTIFICATIONS_NOT_READ(state) {
            return state.listNotificationNotRead;
        }
    }
};